import { Component, OnInit } from '@angular/core';
import { DataService } from 'app/data.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationBoxComponent } from 'app/components/confirmation-box/confirmation-box.component';

@Component({
  selector: 'app-view-blogs',
  templateUrl: './view-blogs.component.html',
  styleUrls: ['./view-blogs.component.css']
})
export class ViewBlogsComponent implements OnInit {

  blogList = []

  constructor( private superAdminService: DataService, private router: Router, private dialog: MatDialog ) { }

  ngOnInit(): void {
    this.superAdminService.getBlogs().subscribe(data => {
      if(data.status){
        this.blogList = data.blogs
      }
    })
  }

  scroll(el:HTMLElement){
  	el.scrollIntoView();
  }

  editBlog(id){
    this.router.navigate(['admin/blog/edit/'+id])
  }

  deleteBlog(id){
    let dialogRef = this.dialog.open(ConfirmationBoxComponent, {
      width: '400px',
      data: {
        text: 'Are you sure you want to delete this blog?'
      }
    })
    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.superAdminService.deleteBlog(id).subscribe(data => {
          if(data.status){
            let blogIndex = this.blogList.indexOf(this.blogList.find(blog => blog.id == id))
            this.blogList.splice(blogIndex, 1) 
          }
        })
      }
    })
  }

}
